import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { AuthorisingContact, Coordinators } from 'containers/forms/organizations'
import { Form } from 'components/layout'
import { AddressBlock } from 'components/sections/common'
import { Input } from 'components/fields'
import { FloatingBar, Button } from 'components/misc'
import { AwardUnitsOverview } from 'containers/sections/award-units'
import { AwardUnitDetail as AwardUnitDetailComp } from 'components/sections/award-units'
import { apiConfiguration, apiDownloadFile, apiLabels } from 'helpers/decorators/api'
import { FinancialData, LabelsOverview } from 'components/sections/organizations'
import { form, meta } from 'helpers/decorators'
import { getBillingAddressFormStatus } from 'helpers/uiPermissions'
import { CONFIGURATION_KEYS, ORGANIZATION_HIERARCHY } from 'constants/enums'
import validate from './award-unit-detail.validate'
import DetailLoader from 'components/loaders/DetailLoader/DetailLoader'


const enhance = compose(
  meta({
    title: 'Detail',
    intlKey: 'pageTitle.detail',
    dynamicProp: 'organizations.detail.name',
    dynamicPropId: 'organizations.detail.globalId'
  }),
  apiLabels(),
  apiConfiguration({
      getValues: [
        CONFIGURATION_KEYS.isGOPEnabled.id
      ]
    }),
  apiDownloadFile(),
  form({
    form: 'awardUnitUpdate',
    initialProps: 'organizations.detail',
    validate,
  }),
  connect(({ auth, api }) => ({
    blobs: api.blobs,
    activeOrganization: auth.organization,
    labels: api.labels,
    availableLabels: api.labels.available.list,
    organizationLabels: api.labels.organization.list
  }))
)

class AwardUnitDetail extends PureComponent {
  static propTypes = {
    codeLists: PropTypes.object.isRequired,
    files: PropTypes.object.isRequired,
    values: PropTypes.object,
    route: PropTypes.object,
    blobs: PropTypes.object.isRequired,
    change: PropTypes.func.isRequired,
    organizations: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onDownloadFile: PropTypes.func.isRequired,
    updateMyOrganization: PropTypes.func.isRequired,
    onChangeAuthorizingContact: PropTypes.func.isRequired,
    updateOrganizationState: PropTypes.func.isRequired,
    removeOrganization: PropTypes.func.isRequired,
    changeOrganisationMode: PropTypes.func.isRequired,
    onChangeCoordinator: PropTypes.func.isRequired,
    onRemoveCoordinator: PropTypes.func.isRequired,
    onMakeLeadCoordinator: PropTypes.func.isRequired,
    pristine: PropTypes.bool,
    submitSucceeded: PropTypes.bool,
    submitFailed: PropTypes.bool,
    invalid: PropTypes.bool,
    user: PropTypes.object,
    activeOrganization: PropTypes.object,
    configuration: PropTypes.object,
    labels: PropTypes.object.isRequired,
    availableLabels: PropTypes.array.isRequired,
    organizationLabels: PropTypes.array.isRequired,
    onGetOrganizationLabels: PropTypes.func.isRequired,
    onFetchAvailableLabels: PropTypes.func.isRequired,
    onAssignOrganizationLabel: PropTypes.func.isRequired,
    onUnassignOrganizationLabel: PropTypes.func.isRequired
  }

  componentDidMount() {
    const orgId = get(this.props, 'params.id')

    orgId && this.props.onFetchAvailableLabels(null, orgId)
    orgId && this.props.onGetOrganizationLabels(orgId)
  }

  componentWillReceiveProps = nextProps => {
    const { params } = this.props

    if (
        get(params, 'id') !==
        get(nextProps, 'params.id')
    ) {
      const orgId = get(nextProps, 'params.id')

      orgId && this.props.onFetchAvailableLabels(null, orgId)
      orgId && this.props.onGetOrganizationLabels(orgId)
    }
  }

  render() {
    const {
      codeLists,
      handleSubmit,
      pristine,
      submitSucceeded,
      submitFailed,
      invalid,
      organizations,
      change,
      blobs,
      files,
      values,
      route,
      user,
      configuration,
      organizationLabels,
      labels,
      availableLabels,
      activeOrganization,
      onFetchAvailableLabels,
      onAssignOrganizationLabel,
      onUnassignOrganizationLabel,
      onGetOrganizationLabels
    } = this.props


    const isIac = ORGANIZATION_HIERARCHY.IAC.id === get(organizations, 'detail.organizationHierarchyLevel.id')

    const orgId = get(this.props, 'params.id')

    const isLabelsEnabled = get(configuration, `valuesByOrganizationId[${get(activeOrganization, 'id')}][${CONFIGURATION_KEYS.enableOrganizationLabels.id}].booleanValue`)

    const [isLicenseeFieldVisible, isAddressReadOnly] = getBillingAddressFormStatus(
      user,
      get(organizations, 'detail.hierarchyLevel.value')
    )

    const loading = organizations.loading || blobs.loading

    return (
      <Form
        onSubmit={handleSubmit(this.props.updateMyOrganization)}
        loading={loading}
        contentLoader={<DetailLoader modulesCount={3} withLogo />}
      >
        <div className="row">
          <div className="col-xs-6">
            <AwardUnitDetailComp
              organizationTypes={codeLists.organizationTypes.list}
              data={values}
              change={change}
              files={files}
              onDownloadFile={this.props.onDownloadFile}
            />
          </div>
          <div className="col-xs-6">
            <AwardUnitsOverview
              updateOrganizationState={this.props.updateOrganizationState}
              removeOrganization={this.props.removeOrganization}
              changeOrganisationMode={this.props.changeOrganisationMode}
              organizationStates={get(codeLists, 'organizationStates.list')}
              data={values}
              isIac={get(route, 'isIac')}
            />

            {isIac && <FinancialData />}
            <AuthorisingContact
                data={get(organizations, 'detail.authorizingContact')}
                organizationId={get(values, 'id')}
                onContactChange={this.props.onChangeAuthorizingContact}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6">
            <AddressBlock
              title="Billing Address"
              intlKey="moduleTitle.billing_address"
              formPrefix="invoiceAddress"
              readOnly={isAddressReadOnly}
              prependFields={
                isLicenseeFieldVisible ? (
                  <Input
                    label="Organisation Invoicing Name"
                    intlKey="label.organisation_invoicing_name"
                    name={'invoicingName'}
                    readonly={isAddressReadOnly}
                  />
                ) : null
              }
              isOrganizationAddress
            />

            <AddressBlock
              title="Shipping Address"
              intlKey="moduleTitle.shipping_address"
              formPrefix="address"
              copyFrom="invoiceAddress"
              withAction
              data={values}
              change={change}
              isOrganizationAddress
            />
          </div>

          <div className="col-xs-6">
            <Coordinators
              data={get(organizations, 'detail.coordinators')}
              organizationId={get(values, 'id')}
              onContactChange={this.props.onChangeCoordinator}
              onRemoveCoordinator={this.props.onRemoveCoordinator}
              onMakeLeadCoordinator={this.props.onMakeLeadCoordinator}
              decoFilter="isAwardLeader"
            />
          </div>

          {isLabelsEnabled && <div className="col-xs-6"><LabelsOverview
              data={organizationLabels}
              labels={labels}
              availableLabels={availableLabels}
              onFetchAvailableLabels={onFetchAvailableLabels}
              onAssignOrganizationLabel={onAssignOrganizationLabel}
              onUnassignOrganizationLabel={onUnassignOrganizationLabel}
              onGetOrganizationLabels={onGetOrganizationLabels}
              organizationId={orgId}
          /> </div>}


        </div>
        <FloatingBar>
          <Button
            intlKey="button.save"
            pristine={pristine}
            submitSucceeded={submitSucceeded}
            submitFailed={submitFailed}
            invalid={invalid}
          >
            Save
          </Button>
        </FloatingBar>
      </Form>
    )
  }
}

export default enhance(AwardUnitDetail)
